// ===== SHOPIFY AJAX CART HELPERS =====
async function getShopifyCart() {
    try {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Cart fetch failed: ' + res.status);
        return await res.json();
    } catch (e) {
        console.warn('[Cart] getShopifyCart error:', e.message);
        return { items: [], item_count: 0, total_price: 0 };
    }
}

async function addShopifyItem(id, qty) {
    if (qty === undefined) qty = 1;
    var numericId = Number(id);
    if (!numericId || isNaN(numericId)) throw new Error('Invalid variant ID: ' + id);
    var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: numericId, quantity: qty }] })
    });
    var data = await res.json();
    if (!res.ok) {
        var msg = data.description || data.message || 'Cart add failed (HTTP ' + res.status + ')';
        console.error('[Cart] addShopifyItem failed:', msg, 'variant:', numericId);
        throw new Error(msg);
    }
    return data;
}

// ===== PRICE FORMATTING =====
// Formats a rupee amount (NOT paise) with ₹ symbol and Indian locale commas
// e.g. formatPrice(1989) → '₹1,989'  |  formatPrice(1690.65) → '₹1,690.65'
function formatPrice(rupees) {
    if (rupees == null) return '';
    if (rupees % 1 === 0) {
        return '₹' + rupees.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    } else {
        return '₹' + rupees.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
}

// ===== RENDER PRODUCTS =====
function renderProducts(filter = 'all') {
    const grid = document.getElementById('productsGrid');
    if (!grid || typeof products === 'undefined') return;

    let filtered = filter === 'all' ? [...products] : products.filter(p => {
        const typeInfo = [
            (p.category || '').toLowerCase(),
            ...(p.tags || []).map(t => t.toLowerCase()),
            ...(p.collections || []).map(c => c.toLowerCase())
        ];
        return typeInfo.includes(filter.toLowerCase());
    });

    const customOrder = ["atta", "gobindo", "royal", "delux", "prime", "superior", "classic", "unpolished", "jeera", "4094", "super ratna", "regular ratna", "bundle"];
    filtered.sort((a, b) => {
        const aTitle = (a.name || '').toLowerCase();
        const aType = (a.category || '').toLowerCase();
        const bTitle = (b.name || '').toLowerCase();
        const bType = (b.category || '').toLowerCase();
        const aHandle = (a.handle || '').toLowerCase();
        const bHandle = (b.handle || '').toLowerCase();
        
        const isABundle = aTitle.includes('bundle') || aType.includes('bundle') || aHandle.includes('bundle') || aTitle.includes('super saver combo');
        const isBBundle = bTitle.includes('bundle') || bType.includes('bundle') || bHandle.includes('bundle') || bTitle.includes('super saver combo');
        
        let aIndex = customOrder.findIndex(keyword => {
            if (isABundle) return keyword === 'bundle';
            return keyword !== 'bundle' && (aTitle.includes(keyword) || aType.includes(keyword));
        });
        let bIndex = customOrder.findIndex(keyword => {
            if (isBBundle) return keyword === 'bundle';
            return keyword !== 'bundle' && (bTitle.includes(keyword) || bType.includes(keyword));
        });
        
        if (aIndex === -1) aIndex = 999;
        if (bIndex === -1) bIndex = 999;
        
        if (aIndex !== bIndex) return aIndex - bIndex;
        return products.indexOf(a) - products.indexOf(b);
    });

    grid.innerHTML = '';

    filtered.forEach((p, i) => {
        const badgeClass = p.badge.includes('Best') ? 'best' : p.badge.toLowerCase().replace(/[^a-z]/g, '') || '';
        const card = document.createElement('div');
        card.className = 'product-card visible';
        // Combine category, tags, and collections into data-type for robust filtering
        const typeInfo = [
            (p.category || '').toLowerCase(),
            ...(p.tags || []).map(t => t.toLowerCase()),
            ...(p.collections || [])
        ].join(' ');
        card.setAttribute('data-type', typeInfo);
        card.style.animationDelay = `${i * 60}ms`;
        card.innerHTML = `
            ${p.badge ? `<span class="pc-badge ${badgeClass}">${p.badge}</span>` : ''}
            <button class="pc-quick" onclick="openQuickView(${p.id})" title="Quick View">👁</button>
            <div class="pc-image" onclick="window.location.href='/products/${p.handle}'">
                <img src="${p.image}" alt="${p.name}" loading="lazy" />
            </div>
            <div class="pc-body">
                <div class="pc-category">${p.category}</div>
                <h3 class="pc-name">${p.name}</h3>
                <div class="pc-variants" data-pid="${p.id}">
                    ${p.variants.map((v, vi) => {
                        let title = v.w;
                        const isCombo = (p.name || '').toLowerCase().includes('bundle') || 
                                        (p.name || '').toLowerCase().includes('super saver combo') || 
                                        (p.category || '').toLowerCase().includes('bundle') || 
                                        (p.handle || '').toLowerCase().includes('bundle');
                        if (title === 'Default Title' && isCombo) {
                            title = 'Bundles';
                        }
                        return `<button class="pc-variant${vi === 0 ? ' active' : ''}" data-vid="${v.id}" onclick="selectVariant(${p.id},${v.id},this)">${title}</button>`;
                    }).join('')}
                </div>
                <div class="pc-footer">
                    <div class="pc-price-wrapper" style="display: flex; align-items: center; gap: 8px;">
                        <span class="compare-price" id="compare-price-${p.id}" style="text-decoration: line-through; color: var(--gray-400); font-size: 14px; font-weight: normal; ${p.variants[0].cp && p.variants[0].cp > p.variants[0].p ? '' : 'display: none;'}">
                            ${p.variants[0].cp ? formatPrice(p.variants[0].cp) : ''}
                        </span>
                        <div class="pc-price" id="price-${p.id}">${formatPrice(p.variants[0].p)}</div>
                    </div>
                    <button class="pc-add" id="add-${p.id}" onclick="addFromCard(${p.id},this)">+</button>
                </div>
            </div>
        `;
        grid.appendChild(card);
    });
    // Animate in
    requestAnimationFrame(() => {
        grid.querySelectorAll('.product-card').forEach((c, i) => {
            setTimeout(() => { c.classList.add('visible'); }, i * 60);
        });
    });
}

// Track selected variant per product (Shopify Variant ID)
const selectedVariants = {};

function selectVariant(pid, vid, btn) {
    selectedVariants[pid] = vid;
    const container = btn.closest('.product-card') || btn.closest('.pc-body') || btn.closest('.pc-variants');
    if (container) {
        const activeBtn = container.querySelector(`.pc-variant[data-vid="${vid}"]`) || btn;
        container.querySelectorAll('.pc-variant').forEach(b => b.classList.remove('active'));
        activeBtn.classList.add('active');
    }
    const p = products.find(x => x.id === pid);
    if (p) {
        const v = p.variants.find(x => x.id === vid);
        if (v) {
            const priceEl = document.getElementById(`price-${pid}`);
            if (priceEl) priceEl.textContent = formatPrice(v.p);
            
            const compareEl = document.getElementById(`compare-price-${pid}`);
            if (compareEl) {
                if (v.cp && v.cp > v.p) {
                    compareEl.textContent = formatPrice(v.cp);
                    compareEl.style.display = 'inline';
                } else {
                    compareEl.style.display = 'none';
                }
            }
        }
    }
}

async function addFromCard(pid, btn) {
    const p = typeof products !== 'undefined' ? products.find(x => x.id === pid) : null;
    let vid;

    // Check if we are on a collection page with variant buttons
    const container = btn.closest('.product-card') || btn.closest('.pc-body');
    if (container) {
        const activeVar = container.querySelector('.pc-variant.active');
        if (activeVar && activeVar.dataset.vid) {
            vid = parseInt(activeVar.dataset.vid, 10);
        }
    }

    if (!vid) vid = parseInt(selectedVariants[pid] || (p && p.variants[0].id), 10);

    if (!vid || isNaN(vid)) {
        console.error('addFromCard: could not determine variant ID for product', pid);
        return;
    }

    btn.classList.add('loading');
    btn.disabled = true;
    try {
        await addShopifyItem(vid, 1);
        btn.innerHTML = '<i data-lucide="check" style="width:20px;height:20px"></i>';
        if (window.lucide) lucide.createIcons();
        btn.classList.add('added');
        setTimeout(() => {
            btn.innerHTML = '+';
            btn.classList.remove('added', 'loading');
            btn.disabled = false;
        }, 1200);
        await updateCart();
        // Only open cart if it isn't already open
        const cd = document.getElementById('cartDrawer');
        if (cd && !cd.classList.contains('active')) toggleCart();
    } catch (e) {
        console.error('Cart add failed:', e.message);
        btn.innerHTML = '!';
        if (e.message && (e.message.toLowerCase().includes('sold out') || e.message.toLowerCase().includes('inventory'))) {
            alert('Sorry, this variant is currently out of stock.');
        }
        setTimeout(() => {
            btn.innerHTML = '+';
            btn.classList.remove('loading');
            btn.disabled = false;
        }, 1500);
    }
}

// ===== FILTER =====
function filterProducts(cat) {
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    const btns = document.querySelectorAll('.filter-btn');
    btns.forEach(b => { if (b.textContent.toLowerCase().includes(cat === 'all' ? 'all' : cat)) b.classList.add('active'); });
    renderProducts(cat);
    const prodSection = document.getElementById('products');
    if (prodSection) prodSection.scrollIntoView({ behavior: 'smooth' });
}

// ===== CART UI =====
function formatRupees(paise) {
    const rupees = paise / 100;
    if (rupees % 1 === 0) {
        return rupees.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    } else {
        return rupees.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
}

// Tracks active discount so updateCart() can show discounted total
let _cartDiscountState = null;
let currentRecommendationId = null;
async function updateCart(cartData = null) {
    const cart = cartData || await getShopifyCart();
    const countEl = document.getElementById('cartCount');
    if (countEl) countEl.textContent = cart.item_count;

    // ─── CART PAGE DYNAMIC UPDATES ──────────────────────────────────────────
    const cartPageItems = document.querySelectorAll('.cart-page-item');
    const cartPageSummaryItems = document.querySelectorAll('.cart-page-summary-item');
    const pct = (_cartDiscountState && _cartDiscountState.eligible && _cartDiscountState.percent > 0) ? _cartDiscountState.percent : 0;

    function updateItemPrices(itemElements, priceSelector) {
        itemElements.forEach(el => {
            const isBundle = el.getAttribute('data-is-bundle') === 'true';
            const origLinePrice = parseInt(el.getAttribute('data-original-line-price')) || 0;
            const linePrice = parseInt(el.getAttribute('data-line-price')) || 0;
            const priceEl = el.querySelector(priceSelector);
            if (!priceEl) return;

            let finalLinePrice = linePrice;
            let showComparePrice = false;
            let compareLinePrice = origLinePrice;

            if (pct > 0 && !isBundle) {
                finalLinePrice = Math.round(origLinePrice * (1 - pct / 100));
                showComparePrice = true;
                compareLinePrice = origLinePrice;
            } else if (origLinePrice > linePrice) {
                finalLinePrice = linePrice;
                showComparePrice = true;
                compareLinePrice = origLinePrice;
            }

            if (showComparePrice) {
                priceEl.innerHTML = `<span style="text-decoration: line-through; color: #888; font-size: 0.85em; margin-right: 5px;">₹${formatRupees(compareLinePrice)}</span>₹${formatRupees(finalLinePrice)}`;
            } else {
                priceEl.innerHTML = `₹${formatRupees(finalLinePrice)}`;
            }
        });
    }

    if (cartPageItems.length > 0) {
        updateItemPrices(cartPageItems, '.cart-page-item-price');
    }
    if (cartPageSummaryItems.length > 0) {
        updateItemPrices(cartPageSummaryItems, '.cart-page-summary-item-price');
    }

    // Update cart page totals
    const origTotal = cart.original_total_price || cart.total_price;
    let finalTotal = origTotal;
    if (pct > 0) {
        const eligibleSub = _cartDiscountState.eligibleSubtotal !== undefined ? _cartDiscountState.eligibleSubtotal : origTotal;
        const nonEligibleSub = origTotal - eligibleSub;
        finalTotal = Math.round(eligibleSub * (1 - pct / 100)) + nonEligibleSub;
    } else if (cart.original_total_price > cart.total_price) {
        finalTotal = cart.total_price;
    }

    const subtotalEl = document.getElementById('cartPageSubtotal');
    const grandTotalEl = document.getElementById('cartPageTotal');
    const checkoutBtnTotalEl = document.querySelector('.cart-page-total-price');

    if (subtotalEl) {
        if (pct > 0 || cart.original_total_price > cart.total_price) {
            subtotalEl.innerHTML = `<span style="text-decoration:line-through;color:#999;font-size:0.82em;font-weight:normal;margin-right:6px">₹${formatRupees(origTotal)}</span><span style="color:#2e7d32;font-weight:800">₹${formatRupees(finalTotal)}</span>`;
        } else {
            subtotalEl.innerHTML = `₹${formatRupees(origTotal)}`;
        }
    }
    if (grandTotalEl) {
        if (pct > 0 || cart.original_total_price > cart.total_price) {
            grandTotalEl.innerHTML = `<span style="text-decoration:line-through;color:#999;font-size:0.82em;font-weight:normal;margin-right:6px">₹${formatRupees(origTotal)}</span><span style="color:#2e7d32;font-weight:800">₹${formatRupees(finalTotal)}</span>`;
        } else {
            grandTotalEl.innerHTML = `₹${formatRupees(origTotal)}`;
        }
    }
    if (checkoutBtnTotalEl) {
        checkoutBtnTotalEl.innerHTML = `₹${formatRupees(finalTotal)}`;
    }

    const itemsEl = document.getElementById('cartItems');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
        itemsEl.innerHTML = `
            <div class="cart-empty">
                <span>🛒</span>
                <p>Your cart is empty</p>
                <a href="/collections/all" onclick="toggleCart()" class="btn-primary" style="font-size:14px;padding:10px 24px">Browse Products</a>
            </div>`;
        const footerEl = document.getElementById('cartFooter');
        if (footerEl) footerEl.style.display = 'none';
        const recEl = document.getElementById('cartRecommendations');
        if (recEl) recEl.style.display = 'none';
    } else {
        const footerEl = document.getElementById('cartFooter');
        if (footerEl) footerEl.style.display = 'block';

        const totalEl = document.getElementById('cartTotal');
        if (totalEl) {
            // Base original total (always pre-discount)
            const origTotal = cart.original_total_price || cart.total_price;

            // If we have an active threshold discount, calculate and show discounted price
            if (_cartDiscountState && _cartDiscountState.eligible && _cartDiscountState.percent > 0) {
                const pct = _cartDiscountState.percent;
                const eligibleSub = _cartDiscountState.eligibleSubtotal !== undefined ? _cartDiscountState.eligibleSubtotal : origTotal;
                const nonEligibleSub = origTotal - eligibleSub;
                const discountedTotal = Math.round(eligibleSub * (1 - pct / 100)) + nonEligibleSub;
                const savedAmount = origTotal - discountedTotal;
                totalEl.innerHTML = [
                    `<span style="text-decoration:line-through;color:#999;font-size:0.82em;font-weight:normal;margin-right:6px">`,
                    `₹${formatRupees(origTotal)}`,
                    `</span>`,
                    `<span style="color:#2e7d32;font-weight:800">₹${formatRupees(discountedTotal)}</span>`,
                ].join('');
            } else if (cart.original_total_price > cart.total_price) {
                // Shopify already applied a discount (e.g. compare-at prices)
                totalEl.innerHTML = [
                    `<span style="text-decoration:line-through;color:#999;font-size:0.82em;font-weight:normal;margin-right:6px">`,
                    `₹${formatRupees(cart.original_total_price)}`,
                    `</span>`,
                    `₹${formatRupees(cart.total_price)}`,
                ].join('');
            } else {
                totalEl.innerHTML = cart.total_price > 0
                    ? `₹${formatRupees(cart.total_price)}`
                    : '0';
            }
        }

        itemsEl.innerHTML = cart.items.map((item) => {
            let vTitle = item.variant_title;
            if (!vTitle || String(vTitle) === 'null' || vTitle === 'Default Title') {
                const pTitle = (item.product_title || '').toLowerCase();
                if (pTitle.includes('combo') || pTitle.includes('bundle')) {
                    vTitle = 'Super Saver Bundle';
                } else {
                    vTitle = '';
                }
            }

            // Calculate correct price for the item considering the active discount
            const handle = (item.handle || '').toLowerCase();
            const type   = (item.product_type || '').toLowerCase();
            const title  = (item.product_title || item.title || '').toLowerCase();
            const isBundle = handle.includes('bundle') || type.includes('bundle') || title.includes('bundle');

            const origLinePrice = item.original_line_price;
            let finalLinePrice = item.line_price;
            let showComparePrice = false;
            let compareLinePrice = origLinePrice;

            if (_cartDiscountState && _cartDiscountState.eligible && _cartDiscountState.percent > 0 && !isBundle) {
                finalLinePrice = Math.round(origLinePrice * (1 - _cartDiscountState.percent / 100));
                showComparePrice = true;
                compareLinePrice = origLinePrice;
            } else if (origLinePrice > item.line_price) {
                finalLinePrice = item.line_price;
                showComparePrice = true;
                compareLinePrice = origLinePrice;
            }

            return `
            <div class="cart-item">
                <div class="ci-img"><img src="${item.image}" alt="${item.title}" /></div>
                <div class="ci-info">
                    <div class="ci-name">${item.product_title}</div>
                    <div class="ci-weight">${vTitle}</div>
                    <div class="ci-bottom">
                        <div class="ci-qty">
                            <button type="button" onclick="changeShopifyQty('${item.key}', ${item.quantity - 1})">−</button>
                            <span>${item.quantity}</span>
                            <button type="button" onclick="changeShopifyQty('${item.key}', ${item.quantity + 1})">+</button>
                        </div>
                        <div class="ci-price">
                            ${showComparePrice ? `<span style="text-decoration: line-through; color: #888; font-size: 0.85em; margin-right: 5px;">₹${formatRupees(compareLinePrice)}</span>` : ''}
                            ₹${formatRupees(finalLinePrice)}
                        </div>
                    </div>
                </div>
            </div>
        `}).join('');

        // --- Cross-Sell / Bundle Recommendations ---
        const recEl = document.getElementById('cartRecommendations');
        if (recEl && typeof products !== 'undefined') {
            const inCartIds = cart.items.map(i => i.product_id);
            // Exclude products already in cart AND any bundles
            const eligibleProducts = products.filter(p => {
                if (inCartIds.includes(p.id)) return false;
                const nameCheck = (p.name || '').toLowerCase();
                const catCheck = (p.category || '').toLowerCase();
                const tagsCheck = (p.tags || []).map(t => t.toLowerCase()).join(' ');
                // Exclude if it's a bundle product
                if (nameCheck.includes('bundle') || catCheck.includes('bundle') || tagsCheck.includes('bundle')) return false;
                return true;
            });
            
            let recommended = null;
            if (eligibleProducts.length > 0) {
                // Keep current recommendation if still eligible to prevent flickering on qty changes
                if (currentRecommendationId && eligibleProducts.some(p => p.id === currentRecommendationId)) {
                    recommended = eligibleProducts.find(p => p.id === currentRecommendationId);
                } else {
                    // Pick a new random product
                    const randomIndex = Math.floor(Math.random() * eligibleProducts.length);
                    recommended = eligibleProducts[randomIndex];
                    currentRecommendationId = recommended.id;
                }
            } else {
                currentRecommendationId = null;
            }

            if (recommended) {
                const vid = recommended.variants[0].id;
                const origP = recommended.variants[0].p;

                recEl.style.display = 'block';
                recEl.innerHTML = `
                    <div style="font-size:10px;text-transform:uppercase;color:#888;font-weight:600;margin-bottom:6px;letter-spacing:.3px;">👥 People Also Buy</div>
                    <div style="display:flex;gap:8px;align-items:center;background:#fff;padding:6px 10px;border-radius:8px;box-shadow:0 1px 4px rgba(0,0,0,0.05);border:1px solid #f0f0f0;">
                        <img src="${recommended.image}" style="width:40px;height:40px;object-fit:cover;border-radius:4px;flex-shrink:0;" alt="${recommended.name}">
                        <div style="flex:1;min-width:0;">
                            <div style="font-size:12px;font-weight:600;color:#222;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${recommended.name}</div>
                            <div style="margin-top:2px;">
                                <span style="color:#2e7d32;font-weight:700;font-size:12px;">₹${origP}</span>
                                <span style="background:#e8f5e9;color:#2e7d32;font-size:9px;font-weight:700;padding:0px 4px;border-radius:2px;margin-left:3px;">Add for bundle!</span>
                            </div>
                        </div>
                        <button onclick="addRecommended(${vid}, this)" style="background:var(--green,#4CAF50);color:#fff;border:none;padding:5px 10px;border-radius:4px;font-size:11px;font-weight:700;cursor:pointer;white-space:nowrap;">+ Add</button>
                    </div>`;
            } else {
                recEl.style.display = 'none';
            }
        }
    }
}

// Adds a recommended product to cart AND refreshes the cart drawer in-place
async function addRecommended(variantId, btn) {
    btn.disabled = true;
    btn.textContent = '...';
    try {
        await addShopifyItem(variantId, 1);
        await updateCart();
        if (window.CartDiscount) CartDiscount.check();
        document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));
    } catch(e) {
        console.error('addRecommended failed', e);
        btn.disabled = false;
        btn.textContent = '+ Add';
        if (e.message && (e.message.toLowerCase().includes('sold out') || e.message.toLowerCase().includes('inventory'))) {
            alert('Sorry, this item is currently out of stock.');
        }
    }
}

async function changeShopifyQty(key, qty) {
    try {
        var res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: key, quantity: qty })
        });
        if (!res.ok) throw new Error('Cart change failed: ' + res.status);
        var cart = await res.json();
        await updateCart(cart);
    } catch (e) {
        console.error('[Cart] changeShopifyQty failed:', e.message);
        // Fallback: refresh cart from server
        await updateCart();
    }
}

function toggleCart() {
    const cd = document.getElementById('cartDrawer');
    const co = document.getElementById('cartOverlay');
    if (!cd || !co) return;
    cd.classList.toggle('active');
    co.classList.toggle('active');
    document.body.style.overflow = cd.classList.contains('active') ? 'hidden' : '';
}

// ===== SEARCH =====
function searchProducts(query) {
    const results = document.getElementById('searchResults');
    if (!results) return;
    if (!query.trim()) { results.innerHTML = ''; return; }
    const q = query.toLowerCase();
    const matches = products.filter(p =>
        p.name.toLowerCase().includes(q) ||
        p.category.includes(q) ||
        p.tags.some(t => t.toLowerCase().includes(q))
    );
    results.innerHTML = matches.length ? matches.map(p => `
        <div class="sr-item" onclick="window.location.href='/products/${p.handle}'">
            <img src="${p.image}" alt="" />
            <div>
                <h4>${p.name}</h4>
                <span>From ₹${p.variants[0].p}${p.variants[0].cp && p.variants[0].cp > p.variants[0].p ? ` <span style="text-decoration: line-through; color: var(--gray-400); font-size: 0.9em; margin-left: 5px;">₹${p.variants[0].cp}</span>` : ''}</span>
            </div>
        </div>
    `).join('') : '<div class="sr-item"><div><h4>No products found</h4><span>Try a different search term</span></div></div>';
}

// ===== QUICK VIEW =====
function openQuickView(pid) {
    const p = products.find(x => x.id === pid);
    if (!p) return;
    const inner = document.getElementById('qvInner');
    const v0 = p.variants[0];
    const hasCompare = v0.cp && v0.cp > v0.p;
    inner.innerHTML = `
        <div class="qv-img"><img src="${p.image}" alt="${p.name}" /></div>
        <div class="qv-details">
            <div class="qv-cat">${p.category}</div>
            <h2>${p.name}</h2>
            <p class="qv-desc">${p.desc}</p>
            <div class="qv-features">${p.features.map(f => `<span class="qv-feat">${f}</span>`).join('')}</div>
            <div class="qv-variants">
                ${p.variants.map((v, i) => `<button class="qv-var${i === 0 ? ' active' : ''}" onclick="selectQvVariant(this,${pid},${v.id})">${v.w}</button>`).join('')}
            </div>
            <div class="qv-price-row" style="display: flex; align-items: baseline; gap: 10px;">
                <span class="compare-price" id="qv-compare-price" style="text-decoration: line-through; color: var(--gray-400); font-size: 16px; font-weight: normal; ${hasCompare ? '' : 'display: none;'}">₹${v0.cp}</span>
                <span class="qv-price" id="qv-price">₹${v0.p}</span>
            </div>
            <button class="btn-primary" id="qv-add-btn">Add to Cart — ₹${v0.p}</button>
        </div>
    `;

    const addBtn = document.getElementById('qv-add-btn');
    addBtn.onclick = () => addFromCard(pid, addBtn);

    document.getElementById('quickview').classList.add('active');
    document.getElementById('qvOverlay').classList.add('active');
    document.body.style.overflow = 'hidden';
}

function selectQvVariant(btn, pid, vid) {
    const p = products.find(x => x.id === pid);
    const v = p.variants.find(x => x.id === vid);
    btn.parentElement.querySelectorAll('.qv-var').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    document.getElementById('qv-price').textContent = `₹${v.p}`;
    
    const compareEl = document.getElementById('qv-compare-price');
    if (compareEl) {
        if (v.cp && v.cp > v.p) {
            compareEl.textContent = `₹${v.cp}`;
            compareEl.style.display = 'inline';
        } else {
            compareEl.style.display = 'none';
        }
    }
    
    const addBtn = document.getElementById('qv-add-btn');
    addBtn.textContent = `Add to Cart — ₹${v.p}`;
    selectedVariants[pid] = vid;
}

function closeQuickView() {
    document.getElementById('quickview').classList.remove('active');
    document.getElementById('qvOverlay').classList.remove('active');
    document.body.style.overflow = '';
}

// ===== EVENT LISTENERS =====
window.addEventListener('scroll', () => {
    const header = document.getElementById('header');
    if (header) header.classList.toggle('scrolled', window.scrollY > 20);
    const btn = document.getElementById('backToTop');
    if (btn) btn.classList.toggle('visible', window.scrollY > 400);
});

function toggleMobileNav() {
    const nav = document.getElementById('mainNav');
    const overlay = document.getElementById('navOverlay');
    if (nav) {
        nav.classList.toggle('active');
        if (overlay) overlay.classList.toggle('active');
        document.body.style.overflow = nav.classList.contains('active') ? 'hidden' : '';
        if (nav.classList.contains('active') && window.lucide) {
            lucide.createIcons();
        }
    }
}

const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
        if (e.isIntersecting) {
            e.target.classList.add('visible');
            observer.unobserve(e.target);
        }
    });
}, { 
    threshold: 0.01,
    rootMargin: '0px 0px 150px 0px'
});

document.addEventListener('DOMContentLoaded', () => {
    // 1. Initialize section observer immediately to ensure fade-in works even if other JS fails
    try {
        document.querySelectorAll('main section').forEach(s => observer.observe(s));
    } catch (err) {
        console.error('Observer initialization failed:', err);
    }

    // 2. Safe execution of renderProducts
    // (Render is now handled by collection-content.liquid to respect the active collection/hash)

    // 3. Safe execution of updateCart
    try {
        updateCart();
    } catch (err) {
        console.error('updateCart failed:', err);
    }

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            const sm = document.getElementById('searchModal');
            if (sm) sm.classList.remove('active');
            closeQuickView();
            const cd = document.getElementById('cartDrawer');
            if (cd && cd.classList.contains('active')) toggleCart();
        }
    });

    if (window.lucide) lucide.createIcons();

    // ── Discount Progress Bar UI ──
    const DISC_THRESHOLDS = [
    { value: 99900, label: '🚚', name: 'FREE Delivery', milestoneId: 'disc-m1' },
    { value: 149900, label: '10%', name: '10% OFF', milestoneId: 'disc-m2' },
    { value: 249900, label: '15%', name: '15% OFF', milestoneId: 'disc-m3' },
    { value: 349900, label: '20%', name: '20% OFF', milestoneId: 'disc-m4' },
];

    function updateDiscountBar(cartTotal) {
        const banner = document.getElementById('discountBanner');
        const fill = document.getElementById('disc-fill');
        const label = document.getElementById('disc-label');
        if (!banner || !fill || !label) return;

        if (!cartTotal || cartTotal === 0) {
            banner.style.display = 'none';
            return;
        }

        banner.style.display = 'block';

        // Find which tier we are at and what's next
        let nextTier = null;
        let prevMax = 0;
        let activeTierIndex = -1;

        for (let i = 0; i < DISC_THRESHOLDS.length; i++) {
            if (cartTotal >= DISC_THRESHOLDS[i].value) {
                activeTierIndex = i;
            } else {
                if (!nextTier) nextTier = DISC_THRESHOLDS[i];
            }
        }

        // Calculate progress % between last unlocked tier and next
        let fillPct = 0;
        if (activeTierIndex === DISC_THRESHOLDS.length - 1) {
            // All tiers unlocked!
            fillPct = 100;
        } else {
            const rangeStart = activeTierIndex >= 0 ? DISC_THRESHOLDS[activeTierIndex].value : 0;
            const rangeEnd = nextTier ? nextTier.value : DISC_THRESHOLDS[DISC_THRESHOLDS.length - 1].value;
            fillPct = Math.min(100, Math.round(((cartTotal - rangeStart) / (rangeEnd - rangeStart)) * 100));

            // Map fill to segment within the full bar
            // Each tier represents 25% of the total bar
            const segmentSize = 100 / DISC_THRESHOLDS.length;
            const completedSegments = activeTierIndex + 1;
            fillPct = completedSegments * segmentSize + (fillPct / 100) * segmentSize;
        }

        fill.style.width = Math.max(0, fillPct) + '%';

        // Update milestone circles
        // m0 is always the cart icon (start), always "active" style
        const m0 = document.getElementById('disc-m0');
        if (m0) {
            const circle = m0.querySelector('div');
            if (circle) { circle.style.borderColor = '#4CAF50'; circle.style.background = '#1e3a1e'; }
        }

        DISC_THRESHOLDS.forEach((tier, i) => {
            const el = document.getElementById(tier.milestoneId);
            if (!el) return;
            const circle = el.querySelector('div');
            if (!circle) return;
            if (i <= activeTierIndex) {
                // Unlocked!
                circle.style.borderColor = '#4CAF50';
                circle.style.background = '#4CAF50';
                circle.style.color = '#fff';
                circle.textContent = '✓';
                el.querySelector('span').style.color = '#4CAF50';
            } else {
                // Locked
                circle.style.borderColor = '#444';
                circle.style.background = '#222';
                circle.style.color = '#888';
                circle.textContent = tier.label;
                el.querySelector('span').style.color = '#888';
            }
        });

        // Update label text
        if (activeTierIndex === DISC_THRESHOLDS.length - 1) {
            label.innerHTML = `🎉 <strong style="color:#4CAF50">20% OFF unlocked!</strong> You're getting the best deal!`;
        } else if (activeTierIndex >= 0) {
            const unlocked = DISC_THRESHOLDS[activeTierIndex].name;
            const nextName = nextTier.name || nextTier.label;
            const remaining = ((nextTier.value - cartTotal) / 100).toLocaleString('en-IN');
            label.innerHTML = `<strong style="color:#4CAF50">${unlocked} unlocked!</strong> &nbsp;Add ₹${remaining} more for ${nextName.toLowerCase()}`;
        } else {
            const remaining = ((DISC_THRESHOLDS[0].value - cartTotal) / 100).toLocaleString('en-IN');
            label.innerHTML = `🚚 Add <strong style="color:#fff">₹${remaining}</strong> more to unlock <strong style="color:#4CAF50">FREE Delivery</strong>`;
        }
    }

    document.addEventListener('cart:discount:updated', (e) => {
        const d = e.detail;
        const eligibleTotal = (d.eligibleSubtotal !== undefined)
            ? d.eligibleSubtotal
            : (d.cart ? d.cart.original_total_price : 0);
        const cartHasItems = d.cart && d.cart.item_count > 0;

        // Save discount state globally so updateCart() can show discounted total
        _cartDiscountState = d.eligible ? d : null;

        // ── Update checkout button URL ──────────────────────────────────────
        function updateButton(btn, isPageBtn) {
            if (!btn) return;

            let totalWeight = 0;
            if (d.cart && d.cart.items) {
                d.cart.items.forEach(item => {
                    totalWeight += ((item.grams || 0) * item.quantity);
                });
            }
            const totalKg = totalWeight / 1000;
            const warningId = isPageBtn ? 'cartPageWeightLimitWarning' : 'weightLimitWarning';
            let weightWarning = document.getElementById(warningId);

            if (totalKg > 55) {
                btn.href = '#';
                btn.style.opacity = '0.5';
                btn.style.pointerEvents = 'none';

                if (!weightWarning) {
                    weightWarning = document.createElement('div');
                    weightWarning.id = warningId;
                    weightWarning.style.cssText =
                        'background:#fff3cd;color:#856404;padding:10px;border-radius:8px;margin-bottom:10px;font-size:13px;font-weight:600;';
                    btn.parentElement.insertBefore(weightWarning, btn);
                }
                weightWarning.innerHTML =
                    '⚠️ Maximum order limit is 55kg. Please reduce items in your cart.';
            } else if (totalKg > 0 && totalKg < 5) {
                btn.href = '#';
                btn.style.opacity = '0.5';
                btn.style.pointerEvents = 'none';

                if (!weightWarning) {
                    weightWarning = document.createElement('div');
                    weightWarning.id = warningId;
                    weightWarning.style.cssText =
                        'background:#fff3cd;color:#856404;padding:10px;border-radius:8px;margin-bottom:10px;font-size:13px;font-weight:600;';
                    btn.parentElement.insertBefore(weightWarning, btn);
                }
                weightWarning.innerHTML =
                    '⚠️ Minimum order limit is 5kg. Please add more items to your cart.';
            } else {
                btn.style.opacity = '1';
                btn.style.pointerEvents = 'auto';

                if (weightWarning) {
                    weightWarning.remove();
                }

                if (d.eligible && d.code) {
                    btn.href = `/discount/${d.code}?redirect=/checkout`;
                } else {
                    btn.href = '/checkout';
                }
            }
        }

        updateButton(document.getElementById('checkoutBtn'), false);
        updateButton(document.getElementById('cartPageCheckoutBtn'), true);

        // ── Re-render cart total with discount applied ──────────────────────
        if (d.cart) updateCart(d.cart);

        // ── Show/hide discount badge above checkout button ──────────────────
        let badge = document.getElementById('cartDiscountBadge');
        if (d.eligible && d.code && cartHasItems) {
            const savings = Math.round((eligibleTotal * d.percent) / 100);
            const savingsFormatted = formatRupees(savings);
            if (!badge) {
                badge = document.createElement('div');
                badge.id = 'cartDiscountBadge';
                badge.style.cssText = [
                    'margin: 0 0 8px 0',
                    'padding: 8px 12px',
                    'background: linear-gradient(135deg, #1b4d1b, #2e7d32)',
                    'border-radius: 8px',
                    'display: flex',
                    'align-items: center',
                    'gap: 8px',
                    'animation: fadeIn 0.3s ease',
                ].join(';');
                const checkoutBtn = document.getElementById('checkoutBtn');
                if (checkoutBtn && checkoutBtn.parentElement) {
                    checkoutBtn.parentElement.insertBefore(badge, checkoutBtn);
                }
            }
            const isFreeDelivery = d.code === 'FreeDelivery';
            badge.innerHTML = isFreeDelivery ? `
                <span style="font-size:16px">🚚</span>
                <div style="flex:1">
                    <div style="color:#a5d6a7;font-size:10px;font-weight:600;letter-spacing:.5px;text-transform:uppercase">Free Delivery Applied</div>
                    <div style="color:#fff;font-size:12px;font-weight:700;margin-top:1px">
                        <span style="color:#69f0ae">FREE Shipping on this order</span>
                    </div>
                </div>
                <span style="background:#69f0ae;color:#1b4d1b;font-size:10px;font-weight:800;padding:2px 6px;border-radius:4px">${d.code}</span>
            ` : `
                <span style="font-size:16px">🏷️</span>
                <div style="flex:1">
                    <div style="color:#a5d6a7;font-size:10px;font-weight:600;letter-spacing:.5px;text-transform:uppercase">Discount Auto-Applied</div>
                    <div style="color:#fff;font-size:12px;font-weight:700;margin-top:1px">
                        <span style="color:#69f0ae">${d.percent}% OFF</span> · Saving ₹${savingsFormatted}
                    </div>
                </div>
                <span style="background:#69f0ae;color:#1b4d1b;font-size:10px;font-weight:800;padding:2px 6px;border-radius:4px">${d.code}</span>
            `;
            badge.style.display = 'flex';
        } else {
            if (badge) badge.style.display = 'none';
        }

        // ── Update progress bar ─────────────────────────────────────────────
        if (!cartHasItems || eligibleTotal === 0) {
            const banner = document.getElementById('discountBanner');
            if (banner) banner.style.display = 'none';
            return;
        }
        updateDiscountBar(eligibleTotal);
    });

    // After discount is removed, refresh cart
    document.addEventListener('cart:discount:removed', () => {
        _cartDiscountState = null;
        setTimeout(updateCart, 200);
    });
});

